<template>
  <div
    ref="subnav"
    class="sub-navigation"
    @mouseenter="$emit('subnav-open')"
    @mouseleave="$emit('subnav-close')"
    @click.prevent="$emit('subnav-click', $event)"
  >
    <div
      ref="subnavcontent"
      class="sub-navigation__main-content"
      :class="{ 'is-transitioning': isTransitioning }"
      @animationend="$emit('tranistion-end')"
    >
      <div class="sub-navigation__text-content" :class="{ 'wide-desktop-viewport': isWideDesktop }">
        <div class="sub-navigation__block-container">
          <div
            v-for="(block, blockIndex) in blocks"
            :key="blockIndex"
            class="sub-navigation__block"
            @mouseenter="$emit('set-block', blockIndex)"
          >
            <a
              ref="blocktitle"
              :href="block.href"
              class="sub-navigation__block-title"
              :tabindex="!block.href ? -1 : null"
            >
              <div class="sub-navigation__block-title-copy">{{ block.title }}</div>
            </a>
            <div
              v-for="(section, sectionIndex) in block.sections"
              :key="sectionIndex"
              class="sub-navigation__section"
              :class="{
                'sub-navigation__section--no-sublinks': !section.links.length,
              }"
            >
              <a
                class="sub-navigation__section-title"
                :class="{
                  'sub-navigation__section-title--no-href': !section.href,
                  'sub-navigation__section-title--no-sublinks': !section.links.length,
                  'sub-navigation__section-title--last-column': blockIndex === blocks.length - 1,
                }"
                :href="section.href"
              >
                {{ section.title }}
              </a>
              <div class="sub-navigation__links" v-if="section.links.length">
                <a
                  v-for="(link, index) in section.links"
                  :href="link.href"
                  :key="index"
                  class="sub-navigation__link"
                  >{{ link.text }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="sub-navigation__delivery-notice" :style="deliveryNoticeStyle">
          <div class="sub-navigation__delivery-notice-inner">
            <div class="sub-navigation__delivery-separator"></div>
            <div class="sub-navigation__delivery-copy-wrap">
              <span class="sub-navigation__delivery-copy" v-html="formattedDeliveryNotice"></span>
            </div>
          </div>
        </div>
      </div>

      <ImageContentful
        v-if="isTeaserShowing"
        tag="a"
        :href="topic.teaser.ctaLink"
        :src="topic.teaser.imageUrl"
        containerSelector=".sub-navigation__teaser"
        :isBackgroundImage="true"
        :options="{ imageCompression: 61, setHeight: false, retinaSupportFactor: 0.2 }"
        class="sub-navigation__teaser"
        :class="{ 'light-theme': !topic.teaser.theme }"
        @click="$emit('teaser-click')"
      >
        <div class="sub-navigation__teaser-content">
          <p class="sub-navigation__teaser-text">{{ topic.teaser.text }}</p>
          <a :href="topic.teaser.ctaLink" class="sub-navigation__teaser-link">
            {{ topic.teaser.ctaText }}
          </a>
        </div>
      </ImageContentful>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { equalizeLineLengthOnBreak } from '@/helpers/string'
import ImageContentful from '@/components/_shared/ImageContentful.vue'

export default {
  name: 'SubNavigation',
  components: { ImageContentful },
  props: {
    blocks: {
      type: Array,
      required: true,
    },
    isTransitioning: {
      type: Boolean,
    },
    isWideDesktop: {
      type: Boolean,
    },
  },

  computed: {
    ...mapGetters({
      currentTopic: 'nav/currentTopic',
      deliveryNotice: 'nav/deliveryNotice',
      topics: 'nav/topics',
    }),

    deliveryNoticeStyle() {
      return `max-width: ${300 * this.blocks.length}px;`
    },

    formattedDeliveryNotice() {
      return this.deliveryNotice
        ? equalizeLineLengthOnBreak(this.deliveryNotice, { firstLineRatio: 0.6 })
        : ''
    },

    isTeaserShowing() {
      return this.topic.teaser && this.isWideDesktop
    },

    topic() {
      const emptyTopic = { teaser: {}, blocks: [] }
      return this.topics[this.currentTopic] || emptyTopic
    },
  },
}
</script>
